// code generated by pbf v4.0.1

export function readGeo(pbf, end) {
    return pbf.readFields(readGeoField, {lat: 0, lng: 0}, end);
}
function readGeoField(tag, obj, pbf) {
    if (tag === 1) obj.lat = pbf.readFloat();
    else if (tag === 2) obj.lng = pbf.readFloat();
}
export function writeGeo(obj, pbf) {
    if (obj.lat) pbf.writeFloatField(1, obj.lat);
    if (obj.lng) pbf.writeFloatField(2, obj.lng);
}

export function readStation(pbf, end) {
    return pbf.readFields(readStationField, {stationIdx: 0, aqi: 0, geo: undefined, dhours: 0, color: 0}, end);
}
function readStationField(tag, obj, pbf) {
    if (tag === 1) obj.stationIdx = pbf.readVarint();
    else if (tag === 2) obj.aqi = pbf.readVarint(true);
    else if (tag === 3) obj.geo = readGeo(pbf, pbf.readVarint() + pbf.pos);
    else if (tag === 4) obj.dhours = pbf.readVarint(true);
    else if (tag === 5) obj.color = pbf.readVarint();
}
export function writeStation(obj, pbf) {
    if (obj.stationIdx) pbf.writeVarintField(1, obj.stationIdx);
    if (obj.aqi) pbf.writeVarintField(2, obj.aqi);
    if (obj.geo) pbf.writeMessage(3, writeGeo, obj.geo);
    if (obj.dhours) pbf.writeVarintField(4, obj.dhours);
    if (obj.color) pbf.writeVarintField(5, obj.color);
}

export function readFeed(pbf, end) {
    return pbf.readFields(readFeedField, {name: "", stations: []}, end);
}
function readFeedField(tag, obj, pbf) {
    if (tag === 1) obj.name = pbf.readString();
    else if (tag === 2) obj.stations.push(readStation(pbf, pbf.readVarint() + pbf.pos));
}
export function writeFeed(obj, pbf) {
    if (obj.name) pbf.writeStringField(1, obj.name);
    if (obj.stations) for (const item of obj.stations) pbf.writeMessage(2, writeStation, item);
}

export function readMap(pbf, end) {
    return pbf.readFields(readMapField, {feeds: []}, end);
}
function readMapField(tag, obj, pbf) {
    if (tag === 1) obj.feeds.push(readFeed(pbf, pbf.readVarint() + pbf.pos));
}
export function writeMap(obj, pbf) {
    if (obj.feeds) for (const item of obj.feeds) pbf.writeMessage(1, writeFeed, item);
}
